module.exports = __webpack_public_path__ + "static/media/acms_recruit.06408961.svg";